// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Premješteno ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'Dovršena je sljedeća akcija: ' + p['label'],
  accButtonProgressStatus: (p: { label: string }) => 'Sljedeća je akcija u tijeku: ' + p['label'],
  accColorPalette: () => 'Paleta boja',
  accColorSwatch: () => 'Uzorak boje',
  accCommandKey: () => 'Naredba',
  accContextMenuLabel: () => 'akcije',
  accControlKey: () => 'Zatvori',
  accPositionAfter: () => 'nakon',
  accPositionBefore: () => 'prije',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Pritisnite i zadržite ' +
    p['keyPressed'] +
    ' te premjestite tipke, a zatim s pomoću tipki sa strelicama promijenite redoslijed.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Unesite ovakav potpuni datum: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Unesite mjesec i godinu u ovom formatu: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Oznaka',
  chart_labelGroup: () => 'Grupa',
  chart_labelSeries: () => 'Serija',
  chart_labelValue: () => 'Vrijednost',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Odabir vrijednosti.',
  checkbox_helpForCheckbox: () => 'Pomoć za potvrdni okvir',
  checkbox_requiredMessageDetail: () => 'Odabir vrijednosti.',
  checkbox_selected: () => 'Potvrdni okvir uključen',
  checkbox_unselected: () => 'Potvrdni okvir nije uključen',
  close: () => 'Zatvori',
  collection_apply: () => 'Primijeni',
  collection_cancel: () => 'Odustani',
  collection_loaded: () => 'Učitano',
  collection_loading: () => 'Učitavanje',
  collection_noData: () => 'Nema podataka za prikaz.',
  collection_pixels: () => 'px',
  collection_resizeColumnDialog: () => 'Promijeni veličinu stupca',
  collection_resizeColumnMenu: () => 'Promijeni veličinu stupca...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Unesi broj između ' + p['MIN'] + ' i ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Odaberite sve retke',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Odabir retka ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Uzlazno',
  collection_sortColumnMenu: () => 'Poredaj stupac',
  collection_sortDescendingSubMenu: () => 'Silazno',
  collection_sortDisabled: () => 'Bez mogućnosti sortiranja',
  collection_sortEnabled: () => 'Mogućnost sortiranja',
  collection_width: () => 'Širina',
  colorPicker_label: () => 'Birač boje',
  confirmation: () => 'Potvrda',
  datePicker_currentDate: () => 'Trenutni datum',
  datePicker_goToToday: () => 'Idi na današnji dan',
  datePicker_label: () => 'Birač datuma',
  datePicker_month: () => 'Mjesec',
  datePicker_months: () => 'Mjeseci',
  datePicker_next: () => 'Sljedeće',
  datePicker_nextDecade: () => 'Sljedeće desetljeće',
  datePicker_nextMonth: () => 'Sljedeći mjesec',
  datePicker_prev: () => 'Prethodno',
  datePicker_prevDecade: () => 'Prethodno desetljeće',
  datePicker_prevMonth: () => 'Prethodni mjesec',
  datePicker_restricted: () => 'Ograničeno',
  datePicker_selected: () => 'Odabrano',
  datePicker_today: () => 'Danas',
  datePicker_weekNum: (p: { NUM: string }) => 'Tjedan ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Broj tjedna',
  datePicker_year: () => 'Godina',
  datePicker_years: () => 'Godine',
  diagram_promotedLink: () => '1 veza',
  diagram_promotedLinkAriaDesc: () => 'Neizravno',
  diagram_promotedLinks: (p: { num_links: string }) => 'Broj veza: ' + p['num_links'],
  error: () => 'Pogreška',
  expandableList_expandCollapseInstructionText: () =>
    'Za proširivanje i sažimanje upotrijebite tipke sa strelicama',
  expandableList_groupCollapse: () => 'Sakriveno',
  expandableList_groupExpand: () => 'Prošireno',
  filePicker_addFiles: () => 'Dodaj datoteke',
  filePicker_dropzonePrimaryText: () => 'Povuci i ispusti',
  filePicker_dropzoneSecondaryText: () => 'Odaberite datoteku ili je ovdje ispustite',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Odaberite datoteke ili ih ovdje ispustite',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ne možete učitati datoteke koje pripadaju vrsti: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Datoteke učitavajte jednu po jednu',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ne možete učitati datoteke koje pripadaju vrsti ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'nepoznato',
  formControl_clear: () => 'Očisti',
  formControl_day: () => 'Dan',
  formControl_empty_segment: () => 'Pražnjenje',
  formControl_helpAvailable: () => 'Pomoć dostupna',
  formControl_hide: () => 'Sakrij',
  formControl_hour: () => 'Sat',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Dosegnuli ste ograničenje od ' +
    ((
      {
        one: new Intl.NumberFormat('hr').format(p['CHARACTER_LIMIT']) + '-znaka',
        few: new Intl.NumberFormat('hr').format(p['CHARACTER_LIMIT']) + '-znaka'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('hr').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('hr').format(p['CHARACTER_LIMIT']) + '-znakova') +
    '.',
  formControl_loading: () => 'Učitavanje',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Možete unijeti do ' + p['MAX_LENGTH'] + ' znakova.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Prekoračena je maksimalna duljina ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Preostali broj znakova: ' + p['CHARACTER_COUNT'] + '.',
  formControl_millisecond: () => 'Milisekunda',
  formControl_minute: () => 'Minuta',
  formControl_month: () => 'Mjesec',
  formControl_readOnly: () => 'Samo za čitanje',
  formControl_requiredMessageDetail: () => 'Unesite vrijednost.',
  formControl_second: () => 'Sekunda',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Odaberite ' + p['n'] + ' vrijednosti.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Dosegnuli ste ograničenje od ' + p['max'] + ' odabira.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Odaberite ' + p['min'] + ' do ' + p['max'] + ' vrijednosti.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Odaberite najmanje ' + p['min'] + ' vrijednosti.',
  formControl_show: () => 'Prikaži',
  formControl_year: () => 'Godina',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Završetak',
  gantt_labelLabel: () => 'Oznaka',
  gantt_labelRow: () => 'Redak',
  gantt_labelStart: () => 'Početak',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nije pronađena odgovarajuća sekcija.',
  indexer_keyboardInstructionText: () => 'Pritisnite Enter za odabir vrijednosti.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Između ' + p['FROM_SECTION'] + ' i ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dvaput pritisnite i zadržite kako biste otvorili način za poteze, a zatim povucite gore ili dolje za prilagodbu vrijednosti.',
  info: () => 'Informacije',
  inputColor_selectColor: () => 'Odaberite boju',
  inputDateMask_date_cleared: () => 'Datum očišćen',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Pražnjenje',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'gggg',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Unesite datum koji je ' + p['max'] + ' ili raniji.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Unesite datum koji je ' + p['min'] + ' ili kasniji.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Unesite dostupni datum.',
  inputDatePicker_instruction: () => 'Pritisnite Kartica kako biste pristupili kalendaru.',
  inputDatePicker_selectDate: () => 'Odaberite datum',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Kao mjesec i godinu unesite ' + p['max'] + ' ili ranije.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Kao mjesec i godinu unesite ' + p['min'] + ' ili kasnije.',
  inputNumber_converterParseError: () => 'Unesite broj.',
  inputNumber_decrease: () => 'Smanji',
  inputNumber_increase: () => 'Povećaj',
  inputPassword_hidden: () => 'Lozinka skrivena',
  inputPassword_hide: () => 'Sakrij lozinku',
  inputPassword_show: () => 'Prikaži lozinku',
  inputSensitiveText_hidden: () => 'Skriven osjetljivi tekst',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Unesite vrijeme koje je ' + p['max'] + ' ili ranije.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Unesite vrijeme koje je ' + p['min'] + ' ili kasnije.',
  inputTimeMask_time_cleared: () => 'Vrijeme čišćenja',
  labelNone: () => 'Ništa',
  list_msgFetchCompleted: () => 'Učitano',
  list_msgFetchingData: () => 'Učitavanje',
  list_suggestion: () => 'Prijedlog',
  menu_stateLoading: () => 'Učitavanje',
  messageToast_allMessagesClosed: () => 'Zatvorene su sve poruke sa skočnim prozorčićem.',
  message_close: () => 'Zatvori',
  message_confirmation: () => 'Uspješno',
  message_error: () => 'Pogreška',
  message_info: () => 'Informacije',
  message_navigationFromMessagesRegion: () => 'Unos područja poruka. Pritisnite F6 za navigaciju.',
  message_navigationToMessagesRegion: () =>
    'U području za poruke postoje nove poruke. Za navigaciju pritisnite F6.',
  message_navigationToTouch: () => 'U području za poruke postoje nove poruke.',
  message_warning: () => 'Upozorenje',
  noData_message: () => 'Nema stavki za prikaz',
  overflowItemLabel: () => 'Više kartica',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Dvaput pritisnite kako biste zatvorili otvoreni skočni prozor.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Unos skočnog prozora. Pritisnite F6 za navigaciju između skočnog prozora i povezane kontrole.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Otvorio se skočni prozor. Pritisnite F6 za navigaciju između skočnog prozora i povezane kontrole.',
  progressIndeterminate: () => 'U tijeku',
  radioButton_checked: () => 'Označen je izborni gumb',
  radioButton_selected: () => 'Odabran je izborni gumb',
  radioButton_unchecked: () => 'Izborni gumb nije označen',
  radioButton_unselected: () => 'Izborni gumb nije odabran',
  radio_helpForRadio: () => 'Pomoć za izborni gumb',
  radio_requiredMessageDetail: () => 'Odabir vrijednosti.',
  selectMultiple_apply: () => 'Primijeni',
  selectMultiple_back: () => 'Natrag',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'S pomoću tipki za lijevo i desno istaknite odabrane vrijednosti.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pritisnite Backspace ili Delete kako biste uklonili odabranu vrijednost.',
  selectMultiple_selectedValues: () => 'Odabrane vrijednosti',
  selectMultiple_showSelectedValues: () => 'Prikazuju se samo odabrane vrijednosti.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Odabran sljedeći broj vrijednosti: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Dodaj na popis',
  select_addToListAvailable: () => 'Dodavanje na popis dostupno',
  select_closeDropdown: () => 'Pritisnite Escape za zatvaranje.',
  select_moreSearchOptions: () => 'Dodatne opcije pretraživanja',
  select_moreSearchOptionsAvailable: () => 'Dostupne dodatne opcije pretraživanja',
  select_noMatchesFound: () => 'Nije pronađen nijedan rezultat.',
  select_oneMatchFound: () => 'Pronađen jedan rezultat',
  select_requiredMessageDetail: () => 'Odabir vrijednosti.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađen sljedeći broj odgovarajućih rezultata: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađen sljedeći broj ili više odgovarajućih rezultata: ' + p['TOTAL_SIZE'],
  selectorAll_deselectAll: () => 'Poništi sve odabrano',
  selectorAll_selectAll: () => 'Odaberi sve',
  selector_selected: () => 'Potvrdni okvir uključen',
  selector_unselected: () => 'Potvrdni okvir nije uključen',
  sheet_close: () => 'Zatvori',
  switch_off: () => 'Isključeno',
  switch_on: () => 'Uključeno',
  tabBarNavigationList_removeCueText: () => 'Može se ukloniti',
  tabBar_tabContainsErrors: () => 'Sadrži pogreške',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Uklonjeno ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'postoji kontekstni izbornik',
  tabbar_labelMoveLeft: () => 'Pomakni lijevo',
  tabbar_labelMoveRight: () => 'Pomakni desno',
  tabbar_labelRemove: () => 'Ukloni',
  timeComponent_tooltipZoomIn: () => 'Povećaj prikaz',
  timeComponent_tooltipZoomOut: () => 'Smanji prikaz',
  timeConverter_parseError: () => 'Unesite vrijeme dovršetka.',
  train_current: () => 'Trenutačno',
  train_message_type: () => 'Vrsta poruke',
  train_not_visited: () => 'Nije posjećeno',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Korak ' + p['currentStep'] + ' od ' + p['numberOfSteps'],
  train_visited: () => 'Posjećeno',
  userAssistance_learnMore: () => 'Saznajte više',
  userAssistance_required: () => 'Obavezno',
  vis_clearSelection: () => 'Očisti odabrano',
  vis_drillable: () => 'Može se analizirati',
  vis_invalidData: () => 'Podaci nisu valjani',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' od ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Odabir određenog područja',
  vis_marqueeZoomTooltip: () => 'Zumiranje određenog područja',
  vis_noData: () => 'Nema podataka za prikaz',
  vis_panTooltip: () => 'Pomicanje',
  vis_stateCollapsed: () => 'Sakriveno',
  vis_stateExpanded: () => 'Prošireno',
  vis_stateLoaded: () => 'Učitano',
  vis_stateLoading: () => 'Učitavanje',
  vis_stateSelected: () => 'Odabrano',
  vis_stateUnselected: () => 'Poništen odabir',
  warn: () => 'Upozorenje'
};
export default bundle;
